import { render, staticRenderFns } from "./video-card.vue?vue&type=template&id=49df73b3&scoped=true&lang=pug&"
import script from "./video-card.vue?vue&type=script&lang=js&"
export * from "./video-card.vue?vue&type=script&lang=js&"
import style0 from "./video-card.vue?vue&type=style&index=0&id=49df73b3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df73b3",
  null
  
)

export default component.exports